

import React from 'react';
import { useHistory } from 'react-router-dom';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Button from '@material-ui/core/Button';
import Logo from '../assets/broSolat.png';

const NavBar = () => {
  const history = useHistory();

  return (
    <div>
      <AppBar position='static'>
        <Toolbar>
          <img src={Logo} width={50} height={50} style={{ borderRadius: 10, marginRight: 10 }} onClick={() => history.push('/')} />
          <h4 style={{ flexGrow: 1, fontFamily: 'Futura' }} onClick={() => history.push('/')}>BroSolat</h4>

          <Button color='inherit' onClick={() => history.push('/')}>
            <h5 style={{ fontFamily: 'Futura' }}>Home</h5>
          </Button>
          <Button color='inherit' onClick={() => history.push('/privacy')}>
            <h5 style={{ fontFamily: 'Futura' }}>Privacy Policy</h5>
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default NavBar